module.exports = __webpack_public_path__ + "a09893a5e80b757fbfda3034b10a0fcb.pdf";